import { BsAsterisk } from 'react-icons/bs'

const CamposObligatoriosSimbolo = () => {
    return <BsAsterisk size={10}/>
}

export default CamposObligatoriosSimbolo